import PostcodeSearchV2 from '../../../../generic/PostcodeSearchV2';

type PostcodeInputProps = {
  value: number;
  onChange: (value: number) => void;
};

export function PostcodeInput({ value, onChange }: PostcodeInputProps) {
  return (
    <PostcodeSearchV2
      idPostcode={value}
      setIdPostcode={(idPostcode: number) => onChange(idPostcode)}
    />
  );
}
